import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-time-component',
  templateUrl: './view-time-component.component.html',
  styleUrls: ['./view-time-component.component.css']
})
export class ViewTimeComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modules/view-time-component/view-time-component.component.ts